import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AppContext = createContext(null);
export const useApp = () => useContext(AppContext);

export function AppProvider({ children }) {
  const [theme, setTheme] = useState(() => localStorage.getItem("ae_theme") || "dark");
  const [brand, setBrand] = useState(() => localStorage.getItem("ae_brand") || "All brands");
  const [brands, setBrands] = useState([]);
  const [paletteOpen, setPaletteOpen] = useState(false);

  const refreshBrands = useCallback(async () => {
    try {
      const r = await api.get("/resource/brands");
      setBrands(r.data);
      const names = r.data.map((b) => b.name);
      setBrand((cur) => (cur !== "All brands" && !names.includes(cur) ? "All brands" : cur));
      return r.data;
    } catch {
      return [];
    }
  }, []);

  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove("dark", "light");
    root.classList.add(theme);
    localStorage.setItem("ae_theme", theme);
  }, [theme]);

  useEffect(() => {
    localStorage.setItem("ae_brand", brand);
  }, [brand]);

  useEffect(() => {
    refreshBrands();
  }, [refreshBrands]);

  useEffect(() => {
    const onKey = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        setPaletteOpen((v) => !v);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  const toggleTheme = () => setTheme((t) => (t === "dark" ? "light" : "dark"));

  return (
    <AppContext.Provider value={{ theme, toggleTheme, brand, setBrand, brands, refreshBrands, paletteOpen, setPaletteOpen }}>
      {children}
    </AppContext.Provider>
  );
}
